const DEFAULT_NUMBER_OF_VISIBLE_LINES = 6;
export {
  DEFAULT_NUMBER_OF_VISIBLE_LINES
};
